// Traduções dos botões CT-e e MDF-e — coletadas por glob em core/i18n/messages.ts.
export default {
  pt: {
    'documentosFiscais.coluna': 'Documentos',
    'documentosFiscais.cte': 'CT-e',
    'documentosFiscais.mdfe': 'MDF-e',
    'documentosFiscais.cteDica': 'Abrir o DACTE em PDF',
    'documentosFiscais.mdfeDica': 'Abrir o DAMDFE em PDF',
    'documentosFiscais.erro': 'Não foi possível abrir o PDF.',
  },
  en: {
    'documentosFiscais.coluna': 'Documents',
    'documentosFiscais.cte': 'CT-e',
    'documentosFiscais.mdfe': 'MDF-e',
    'documentosFiscais.cteDica': 'Open the DACTE as PDF',
    'documentosFiscais.mdfeDica': 'Open the DAMDFE as PDF',
    'documentosFiscais.erro': 'Could not open the PDF.',
  },
  es: {
    'documentosFiscais.coluna': 'Documentos',
    'documentosFiscais.cte': 'CT-e',
    'documentosFiscais.mdfe': 'MDF-e',
    'documentosFiscais.cteDica': 'Abrir el DACTE en PDF',
    'documentosFiscais.mdfeDica': 'Abrir el DAMDFE en PDF',
    'documentosFiscais.erro': 'No fue posible abrir el PDF.',
  },
}
